import { LedgerView } from "./LedgerView";

export function RewardsPage() {
  return (
    <LedgerView
      title="Rewarded Ads"
      helperText="Coins credited from watching rewarded ads — each one only exists because AdMob's own server independently verified the ad was actually watched (server-side signature verification, see lib/admob-ssv.js), never trusted from the Android app alone."
      fixedReasons={["rewarded_ad"]}
    />
  );
}
